<template>
  <ModalContainer
    :id="props.id"
    animation="fade"
    keyboard="false"
    :backdrop="props.backdrop"
    tabindex="-1"
    aria-labelledby="scrollableLabel"
  >
    <ModalDialog :class="sizeClass" scrollable>
      <ModalContent>
        <ModalBody class="m-2">
          <slot></slot>
        </ModalBody>
      </ModalContent>
    </ModalDialog>
  </ModalContainer>
</template>
<script setup>
import { computed } from "vue";
import ModalContainer from "@/components/uielements/modal/ModalContainer.vue";
import ModalDialog from "@/components/uielements/modal/ModalDialog.vue";
import ModalContent from "@/components/uielements/modal/ModalContent.vue";
import ModalBody from "@/components/uielements/modal/ModalBody.vue";

const props = defineProps({
  id: {
    type: String,
    required: false,
    default: () => "sl-modal",
  },
  backdrop: {
    type: String,
    required: false,
    default: () => "true",
  },
  size: {
    type: String,
    default: "",
  },
});

const sizeClass = computed(() => {
  return props.size ? `modal-${props.size}` : "";
});
</script>
